/** Catalogo CER preferiti locale ( "CER attivi"). */

export interface CerCatalogEntry {
  id: string;
  codice: string;
  descrizione: string;
  stato_fisico: string;
  provenienza: "U" | "S";
  scadenza_analisi?: string;
  predefinito?: boolean;
  created_at: string;
}

const STORAGE_KEY = "rentri.cerCatalog";

function load(): CerCatalogEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as CerCatalogEntry[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function save(items: CerCatalogEntry[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function listCerCatalog(): CerCatalogEntry[] {
  return load().sort((a, b) => a.codice.localeCompare(b.codice));
}

export function upsertCerCatalog(
  entry: Omit<CerCatalogEntry, "id" | "created_at"> & { id?: string },
): CerCatalogEntry {
  const items = load();
  const now = new Date().toISOString();
  if (entry.predefinito) {
    items.forEach((i) => {
      i.predefinito = false;
    });
  }
  if (entry.id) {
    const idx = items.findIndex((i) => i.id === entry.id);
    const updated: CerCatalogEntry = {
      ...items[idx],
      ...entry,
      id: entry.id,
    };
    if (idx >= 0) {
      items[idx] = updated;
      save(items);
      return updated;
    }
  }
  const created: CerCatalogEntry = {
    id: crypto.randomUUID(),
    codice: entry.codice.replace(/\./g, "").trim(),
    descrizione: entry.descrizione,
    stato_fisico: entry.stato_fisico,
    provenienza: entry.provenienza,
    scadenza_analisi: entry.scadenza_analisi,
    predefinito: entry.predefinito ?? false,
    created_at: now,
  };
  items.push(created);
  save(items);
  return created;
}

export function removeCerCatalog(id: string): void {
  save(load().filter((i) => i.id !== id));
}

export function getDefaultCer(): CerCatalogEntry | undefined {
  return load().find((i) => i.predefinito) ?? load()[0];
}
